import {ChangeDetectorRef, Component, EventEmitter, Input, Output} from '@angular/core';
import {NbButtonGroupModule, NbButtonModule, NbIconModule, NbTooltipModule} from '@nebular/theme';

export type Tabs = 'list' | 'table'

@Component({
    selector: 'app-view-changing-tabs',
    templateUrl: './view-changing-tabs.component.html',
    styleUrls: ['./view-changing-tabs.component.scss'],
    imports: [
        NbIconModule,
        NbTooltipModule,
        NbButtonGroupModule,
        NbButtonModule
    ]
})
export class ViewChangingTabsComponent {
  constructor(
    private cdr: ChangeDetectorRef
  ) {
  }

  view: Tabs = localStorage.getItem('damView') as Tabs || 'list';

  @Input() isShowList: boolean;
  @Output() public viewChangeEvent = new EventEmitter<Tabs>();

  showProductBlocks(view: Tabs) {
    this.saveViewOnLocalStorage(view)
    this.view = view
    this.viewChangeEvent.emit(view)
    this.cdr.detectChanges();
  }

  saveViewOnLocalStorage(view: Tabs) {
    localStorage.setItem('damView', view);
  }
}
